import { defineComponent as _defineComponent } from 'vue'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import DangerRiskIcon from './DangerRiskIcon.vue'
import NormalRiskIcon from './NormalRiskIcon.vue'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import FireOubreakCardMenu from './FireOubreakCardMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import FireOutbreakCardReactionMenu from './FireOutbreakCardReactionMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakCard',
  props: {
    alert: null
  },
  emits: ["reaction", "shareTo"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'reaction', value: FireOutbreakReactionEnum): void
	(event: 'shareTo', value: ShareFireOutbreakAlertEnum): void
}), expose: any, slots: any, attrs: any }) {

const { alert } = __props as {
	alert: FireOutbreak
};





return { __sfc: true,emit, DangerRiskIcon, NormalRiskIcon, FireOubreakCardMenu, FireOutbreakCardReactionMenu }
}

})